import { isNull } from 'lodash-es';

export const isSectionChangedSinceMount = ({
  currentSection,
  mountedOnSection,
  isNotificationHiddenOnPrevPage
}) => {
  if (isNull(mountedOnSection)) {
    return false;
  }

  if (!isNotificationHiddenOnPrevPage && currentSection !== mountedOnSection) {
    return true;
  }

  return false;
};
